import { render, staticRenderFns } from "./slider-filter.vue?vue&type=template&id=32e77e0f&"
import script from "./slider-filter.vue?vue&type=script&lang=js&"
export * from "./slider-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports